<template>
  <div class="pay-cont">
    <div class="fee-notice">
      <p class="title">{{ st('finance.processingFeeNoticeTitle') }}</p>
      <artmisads-table
      :columns="columns"
      :data-source="tabelData"
      :bordered="true"
      >

      </artmisads-table>
      <p class="note note-paypal">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-info"></use>
        </svg>
        {{ st('finance.processingFeeDifferentialNote') }}
      </p>
    </div>
    <div class="amount">
      <p class="title">{{ st('finance.amountToPayTitle') }}</p>
      <div class="amount-cont">
        <div class="item">
          <span class="name">{{ st('finance.statementAmountLabel') }}</span>
          <span class="value">{{CURRENCY_DATA_MAPPER[info.amountInfo?.currency]}}{{props.payInfo.originalAmount}}</span>
        </div>
        <div class="item">
          <span class="name">{{ st('finance.labelArtemisAdsServiceFee') }}</span>
          <span class="value">{{CURRENCY_DATA_MAPPER[info.amountInfo?.currency]}}{{props.payInfo.platformFeeAmount}}</span>
        </div>
        <div class="item">
          <span class="name">{{ st('finance.labelProcessingFee') }}</span>
          <span class="value">{{CURRENCY_DATA_MAPPER[info.amountInfo?.currency]}}{{info.amountInfo?.processingFee}}</span>
        </div>
      
        <div class="total">
          <span class="name">{{ st('finance.labelTotalColon') }}</span>
          <span class="value">{{CURRENCY_DATA_MAPPER[info.amountInfo?.currency]}}{{info.amountInfo?.totalAmount}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { CURRENCY_DATA_MAPPER, PAYPAL_FEE } from '@/contants/common';
  import { useUserInfoStore } from '@/storeData/index';
  import { computed } from 'vue';
  import { useSellerI18n } from '@/composables/useSellerI18n';

  const { st } = useSellerI18n();

  const props = defineProps(["payInfo", "methodType"]);
  const store = useUserInfoStore();
  const info = computed(() => {
    let amountInfo = {};
    let noticeInfo = {};
    if (props.payInfo) {
      if (props.methodType === 'paypal') {
        noticeInfo = props.payInfo.paypalFeeNotice;
        amountInfo = props.payInfo.paypalAmountToPay;
      } else if (props.methodType === 'aliPay_cn') {
        noticeInfo = props.payInfo.alipayCnFeeNotice;
        amountInfo = props.payInfo.alipayCnAmountToPay;
      } else if (props.methodType === 'card') {
        noticeInfo = props.payInfo.cardFeeNotice;
        amountInfo = props.payInfo.cardAmountToPay;
      }
    }
    return {
      amountInfo,
      noticeInfo
    }
  })

  const columns = computed(() => [
    {
      title: st('finance.payContColMethod'),
      dataIndex: 'method',
      width: "8%",
    },
    {
      title: st('finance.paymentMethodAlipay'),
      dataIndex: 'alipay',
      width: "8%",
    },
    {
      title: st('finance.paymentMethodCard'),
      dataIndex: 'card',
      width: "30%",
    },
    {
      title: st('finance.paymentMethodPaypal'),
      dataIndex: 'payPal',
      width: "24%",
    },
  ]);

  const tabelData = computed(() => {
    let data = [];
    if (props.payInfo?.alipayCnFeeNotice) {
      data = [{
        method: st('finance.payContFeesRow'),
        alipay: `${props.payInfo.alipayCnFeeNotice.rate}%`,
        card: `${props.payInfo.cardFeeNotice.rate}%`,
        payPal: `${props.payInfo.paypalFeeNotice.rate}% + ${PAYPAL_FEE[store.userInfo.countryCode]}`,
        bankTransfer: st('finance.bankTransferFeePolicyNote'),
      }];
    }
    return data;
  });

</script>

<style lang="less" scoped>
  .pay-cont {
    .title {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      margin-bottom: 16px;
    }
    .fee-notice {
      :deep(.ant-table) {
        .ant-table-container {
          border-radius: 8px 0 0 8px;
        }
        .ant-table-row-level-0 {
          > td:first-child {
            border-radius: 0 0 0 8px;
          }
          > td:last-child {
            border-radius: 0 0 8px 0;
          }
        }
      }
    }
    .amount {
      margin-top: 30px;
    }
    .amount-cont {
      padding: 14px 16px 14px 12px;
      background: var(  --bg-gray-1);
      border-radius: 8px;
      .item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        .name {
          height: 20px;
          font-weight: 500;
          font-size: 13px;
          color: var(--dark-3);
          letter-spacing: 0.3px;
          line-height: 20px;
        }
        .value {
          font-weight: 600;
          font-size: 13px;
          color: var(--dark-1);
          letter-spacing: 0.3px;
          text-align: right;
          line-height: 20px;
        }
      }
      .total {
        display: flex;
        justify-content: flex-end;
        .name {
          height: 20px;
          font-weight: 500;
          font-size: 13px;
          color: var(--dark-3);
          letter-spacing: 0.3px;
          line-height: 20px;
          align-self: center;
        }
        .value {
          font-weight: 600;
          font-size: 18px;
          color: var(--dark-1);
          letter-spacing: 0.4px;
          line-height: 24px;
          margin-left: 8px;
        }
      }
    }
  }
</style>